import { createContext } from 'react'

/**
 * True for a page header drawn under ScreenLayout's section tab strip
 * (SectionTabs). From `lg` up the strip names the page, so TitleRow keeps
 * its `h1` for screen readers only; below `lg` there is no strip and the
 * title shows as always.
 *
 * Its own module so TitleRow and the pending title skeleton read it without
 * importing the layout, and a component file keeps exporting components only.
 */
export const SectionStripContext = createContext(false)
